import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const UserItem = ({ user: { login, avatar_url, html_url } }) => {
  return (
    <div className='col-md-4'>
      <div className='card' style={cardStyle}>
        <img
          src={avatar_url}
          alt=''
          className='img-fluid rounded-circle w-50 mb-3 all-center'
          style={{ width: '60px' }}
        />
        <h1>{login.length > 11 ? login.slice(0, 11) + '...' : login}</h1>
        <div>
          <Link
            to={`/user/${login}`}
            className='btn btn btn my-btn'
            style={btnStyle}
          >
            More
          </Link>
        </div>
      </div>
    </div>
  );
};

UserItem.prototype = {
  user: PropTypes.object.isRequired
};

const cardStyle = {
  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
  marginTop: '20px',
  backgroundColor: '#fff',
  textAlign: 'center',
  borderRadius: '40px',
  paddingBottom: '15px',
  minHeight: '350px'
};

const btnStyle = {
  border: 'none',
  padding: '8px',
  display: 'inline-block',
  color: '#333',
  backgroundColor: '#cd5c5c',
  cursor: 'pointer',
  width: '70%',
  borderRadius: '20px',
  fontSize: '18px',
  textAlign: 'center',
  marginTop: '40px',
  marginBottom: '0'
};
export default UserItem;
